import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { map } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';
import { URLS } from "../../../config/api.config";
import { environment } from "../../../environments/environment";
import { CommonService } from "../../helpers/common.service";
import { CustomEncryption } from "../../../config/custom-encrypt";
import { isPlatformBrowser } from "@angular/common";
import { APP_ENV, AppEnv } from "../../tokens/app-env.token";

@Injectable()
export class LoginService {

	private chkSub = URLS.checkSubscription;
	private userChk = URLS.userType;
	private super = URLS.superstar;
	private req1 = URLS.request1;
	private req2 = URLS.request2;
	private agree = URLS.isAgree;
	private mapRM = URLS.mapRM;
	private subMap = URLS.subBrokerMap;
	private viewBrokerageRights = URLS.viewBrokerageRights;
	private addMenuRights = URLS.addMenuRights;
	private appSettings = URLS.appSetting;

	// for new login config

	private loginIappInfo = URLS.loginAppInfo;
	private loginValidateUser = URLS.loginValidateUser;
	private loginVerifyUserOTP = URLS.loginVerifyUserOTP;
	private loginVerifyUserCredential = URLS.loginVerifyUserCred;
	private loginVerifyUserCredentialCodifi = URLS.loginVerifyUserCredcodifi;
	private loginSetCredential = URLS.loginResetCredential;
	private loginForgetCred = URLS.loginForgetCred;
	private loginForgetCredVarifyOTP = URLS.loginForgetCredVarifyOTP;
	private globalCheckSumkey: any;

	private getTokenForAAA = URLS.generateTokenForAAA;

	private productActDea = URLS.productActivationRights
	private clientCodes = URLS.clientCodesList;
	private verifyOneLogin = URLS.verifyOneLogin;
	private userInfoOneLogin = URLS.userInfoOneLogin;

	//influencer
	//private inflSendOtp = URLS.inflSendOtp
	//private inflVerifyOtp = URLS.inflVerifyOtp
	//private getInfluDetail = URLS.getInfluDetail
	private crmToken = URLS.crmToken;

	// for new login End config
	
	keys: any;
	constructor(private httpClient: HttpClient,
		@Inject(APP_ENV) private appEnv: AppEnv,
		private nativeHttp: HTTP,
		private deviceInfo: DeviceDetectorService,
		private commonService: CommonService,
		private ciphetText: CustomEncryption,@Inject(PLATFORM_ID) private platformId: Object) {
	}

	//new login modules service fun //
	// new server service call start
	sendReqTOServerDashboard(params:any,config:any,reqHead:any): Observable<{}>{ 
		return this.httpClient.post('/api/secure/dashboard-service', {
			params,
			config,
			reqHead
		})
	}


	sendReqTOServer(params:any,config:any,reqHead:any): Observable<{}>{ 
		return this.httpClient.post('/api/secure/login-service', {
			params,
			config,
			reqHead
		})
	}

	sendReqTOServerGet(params:any,config:any,reqHead:any): Observable<{}>{ 
		return this.httpClient.post('/api/secure/login-service-get', {
			params,
			config,
			reqHead
		})
	}

	public checkUser(passObj: any): Observable<{}> {
		const params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
				"appID": "0",
				"osName": this.deviceInfo.os(),
				"osVendor": "Microsoft",
				"osVersion": this.deviceInfo.os_version() == "unknown" ? "Windows-11":this.deviceInfo.os_version()  ,
				"deviceModel": "Latitude 3140",
				"deviceVendor": "Dell",
				"deviceUUID": "",
				"deviceScreen": this.screenSize(),
				"deviceIpImei": "192.168.132.112",
				"appMarket": "Web-Brower",
				"appName": this.deviceInfo.browser(),
				"appVersion": "1.2.2",
				"loginType": passObj.loginType,
				"loginID": this.ciphetText.aesEncrypt(passObj.userId),
				"updatedTimeStamp": "0",
				"userAgent": "AAA-Web"
			}
		}
		if(this.commonService.isApp()){
			params.body.userAgent = "AAA-Mobile";
		}
		else{
			params.body.userAgent = "AAA-Web";
		}
		let reqHead = {
			appID: this.commonService.get('appID') || '',
			'Ocp-Apim-Subscription-Key' : ""
		}
		const config = {
			url: this.loginIappInfo.url,
			key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP'
		} 
		return this.sendReqTOServer(params, config,reqHead);
	}

	public getValidUser(userId: any, appId: any, type: any): Observable<{}> {
		const params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
				"LoginMode": type,
				"CredentialMode": 0,
				"CredentialSet": 0,
				"userID": this.ciphetText.aesEncrypt(userId),
			}
		}
		let reqHead = {
			userAgent: "AAA-WebSite",
			appID: appId,
			'Ocp-Apim-Subscription-Key' : ""
		}
		const config = {
			url: this.loginValidateUser.url,
			key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP'
		} 
		return this.sendReqTOServer(params, config, reqHead);

	}

	public validateOtp(otp: any, appId: any, type: any): Observable<{}> {
		const params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
				"LoginMode": 1,
				"CredentialMode": 2,
				"CredentialSet": 0,
				"userID": this.ciphetText.aesEncrypt(this.commonService.get('userId1')),
				"UserCredential": this.ciphetText.aesEncrypt(otp)
			}
		}


		let reqHead = {
			userAgent: "AAA-WebSite",
			appID: appId,
			'Ocp-Apim-Subscription-Key' : ""
		}
		const config = {
			url: this.loginVerifyUserOTP.url,
			key: 'Verify_Guest_And_ExtendedApi',
			subKey:'AAA_OCP'
		} 
		return this.sendReqTOServer(params, config, reqHead);
	}

	public verifyUserCredential(pin: any, appId: any): Observable<{}> {
			const params = {
				"head": {
					"RequestCode": "CVUpdateLead01",
					"Key": "",
					"AppName": "AAA",
					"AppVer": "01",
					"OsName": "Android",
					"userType": this.commonService.get('userType')
				},
				"body": {
					"LoginMode": 1,
					"CredentialMode": 4,
					"CredentialSet": 0,
					"userID": this.ciphetText.aesEncrypt(this.commonService.get('userId1')),
					"UserCredential": this.ciphetText.aesEncrypt(pin)
				}
			}


			let reqHead = {
				userAgent: "AAA-WebSite",
				appID: appId,
				'Ocp-Apim-Subscription-Key' : ""
			}
			const config = {
				url: this.loginVerifyUserCredential.url,
				key: 'Verify_Guest_And_ExtendedApi',
				subKey:'AAA_OCP'
			} 
			return this.sendReqTOServer(params, config, reqHead);
	}

	public verifyUserCredentialCodifi(jwtToken: string, appId: any): Observable<{}> {
		if (!jwtToken) {
			throw new Error('JWTToken is required to verify the Codifi login credential.');
		}

		const jwtClaims = this.getJwtClaims(jwtToken);
		const credentialEmail = (jwtClaims?.email || '').toString().trim().toLowerCase();
		const credentialUserId = (jwtClaims?.preferred_username || jwtClaims?.upn || '').toString().trim().toLowerCase();

		if (!credentialEmail || !credentialUserId) {
			throw new Error('JWT payload must include email and preferred_username/upn for Codifi checksum generation.');
		}

		const checkSumKey = this.ciphetText.generateCheckSumKey();
		const currentDate = new Date();
		const date = [
			String(currentDate.getDate()).padStart(2, '0'),
			String(currentDate.getMonth() + 1).padStart(2, '0'),
			currentDate.getFullYear()
		].join('');
		// Required checksum input format: email_preferred_username_CheckSumKey_ddMMyyyy
		const checksumInput = `${credentialEmail}_${credentialUserId}_${checkSumKey}_${date}`;
		// console.log('[Codifi Verify] preferred_username:', credentialUserId);
		// console.log('[Codifi Verify] email:', credentialEmail);
		// console.log('[Codifi Verify] checkSumKey:', checkSumKey);
		// console.log('[Codifi Verify] checksumString:', checksumInput);
		
		const checkSumValue = checksumInput;
		//console.log('[Codifi Verify] checksumValue:', checkSumValue);

		const params = {
			head: {
				RequestCode: 'CVUpdateLead01',
				Key: '',
				AppName: 'AAA',
				AppVer: '01',
				OsName: 'Android',
				CheckSumKey: checkSumKey,
				CheckSum: checkSumValue
			},
			body: {
				JWTToken: jwtToken
			}
		};

		const reqHead = {
			useragent: 'AAA',
			token: jwtToken,
			appID: appId,
			'Ocp-Apim-Subscription-Key': ''
		};
		const config = {
			url: this.loginVerifyUserCredentialCodifi.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			headKeyField: 'Key',
			subKey: 'AAA_OCP',
			isCheckSum :true
		};

		return this.sendReqTOServerDashboard(params, config, reqHead);
	}

	private getJwtClaims(jwtToken: string): any {
		const payload = jwtToken?.split('.')[1];
		if (!payload) {
			return {};
		}

		try {
			const normalizedPayload = payload.replace(/-/g, '+').replace(/_/g, '/');
			const paddedPayload = normalizedPayload.padEnd(
				normalizedPayload.length + (4 - normalizedPayload.length % 4) % 4,
				'='
			);
			const decodedPayload = decodeURIComponent(
				atob(paddedPayload)
					.split('')
					.map((character) => `%${character.charCodeAt(0).toString(16).padStart(2, '0')}`)
					.join('')
			);
			return JSON.parse(decodedPayload);
		} catch {
			return {};
		}
	}

	public setCredential(pin: any, appId: any): Observable<{}> {
		const params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
				"UserId": this.ciphetText.aesEncrypt(this.commonService.get('userId1')),
				"CredentialSet": 1,
				"CredentialType": 3,
				"OldCredential": this.ciphetText.aesEncrypt("999999"),
				"NewUserCredential": this.ciphetText.aesEncrypt(pin)
			}
		}

		let reqHead = {
				userAgent: "AAA",
				appID: appId,
				'Ocp-Apim-Subscription-Key' : ""
			}
			const config = {
				url: this.loginSetCredential.url,
				key: 'Verify_Guest_And_ExtendedApi',
				subKey:'AAA_OCP'
			} 
		return this.sendReqTOServer(params, config, reqHead);
	}

	// call forget Pin API
	public forgetPin(type: any, appId: any): Observable<{}> {
		const params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
				"LoginMode": 1,
				"CredentialMode": 1,
				"CredentialSet": 1,
				"userID": this.ciphetText.aesEncrypt(this.commonService.get('userId1'))
			}
		}

		let reqHead = {
				userAgent: "AAA-WebSite",
				appID: appId,
				'Ocp-Apim-Subscription-Key' : ""
			}
			const config = {
				url: this.loginForgetCred.url,
				key: 'Verify_Guest_And_ExtendedApi',
				subKey:'AAA_OCP'
			} 
			return this.sendReqTOServer(params, config, reqHead);
	}

	// call forget Pin API
	public forgetOtpVerify(otp: any, appId: any): Observable<{}> {
		const params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
				"userID": this.ciphetText.aesEncrypt(this.commonService.get('userId1')),
				"CredentialSet": 1,
				"CredentialType": 1,
				"OTP": this.ciphetText.aesEncrypt(otp)
			}
		}
		let reqHead = {
				userAgent: "AAA-WebSite",
				appID: appId,
				'Ocp-Apim-Subscription-Key' : ""
			}
			const config = {
				url: this.loginForgetCredVarifyOTP.url,
				key: 'Verify_Guest_And_ExtendedApi',
				subKey:'AAA_OCP'
			} 
			return this.sendReqTOServer(params, config, reqHead);
		
	}

	public checkSubs(cookieValue: any, id: any): Observable<{}> {
		const params = {
			head: {
				RequestCode: "MFRQLO01",
				Key: "",
				AppVer: "1.0.4.0",
				AppName: "AAA",
				OsName: this.commonService.getPlatform(),
			},
			body: {
				Loginid: id
			}
		}
		let reqHead = {
				userAgent: "AAA-WebSite",
				appID: this.commonService.get('appID') || '',
				'Ocp-Apim-Subscription-Key' : "",
				'token' : cookieValue
			}
			const config = {
				url: this.chkSub.url,
				key: 'Verify_Guest_And_ExtendedApi',
				subKey:'AAA_OCP'
			} 
			return this.sendReqTOServer(params, config, reqHead);
	}

	public getUserType(id: any): Observable<{}> {
		const params = {
			head: {
				RequestCode: "CVUserType01",
				Key: "",
				AppVer: "1.0.22.0",
				AppName: "AAA",
				OsName: this.commonService.getPlatform(),
			},
			body: {
				UserCode: id
			}
		}
		let reqHead = {
				userAgent: "AAA-WebSite",
				appID: this.commonService.get('appID') || '',
				'Ocp-Apim-Subscription-Key' : "",
			}
			const config = {
				url: this.chkSub.url,
				key: 'Verify_Guest_And_ExtendedApi',
				subKey:'AAA_OCP'
			} 
			return this.sendReqTOServer(params, config, reqHead);
	}

	public requestOne(userID?: any, dataParams?: any): Observable<{}> {
		const params: any = {
			"head": {
				"requestCode": "IIFLMarRQLR02",
				"key": "",
				"appVer": "1.0.22.0",
				"appName": "AAA",
				"osName": this.commonService.getPlatform(),
				"LoginId": userID,
				"userType": this.commonService.get('userType')
			}
		}
		params['body'] = dataParams

		let reqHead = {
				userAgent: "AAA-WebSite",
				appID: this.commonService.get('appID') || '',
				'Ocp-Apim-Subscription-Key' : "",
			}
			const config = {
				url: this.req1.url,
				key: 'Verify_Guest_And_ExtendedApi',
				subKey:'TT'
			} 
			return this.sendReqTOServer(params, config, reqHead);
	}

	public requestTwo(dataParams?: any): Observable<{}> {
		const params: any = {
			"head": {
				"requestCode": "CVUpdateLead01",
				"key": "",
				"appVer": "1.0.22.0",
				"appName": "AAA",
				"osName": this.commonService.getPlatform(),
				"userType": this.commonService.get('userType')
			}
		}
		params['body'] = dataParams
		let reqHead = {
				userAgent: "AAA-WebSite",
				appID: this.commonService.get('appID') || '',
				'Ocp-Apim-Subscription-Key' : "",
			}
			const config = {
				url: this.req2.url,
				key: 'Verify_Guest_And_ExtendedApi',
				subKey:'AAA_OCP'
			} 
			return this.sendReqTOServer(params, config, reqHead);
	}

	public getRMMapping(dataParams: any, id: any, cookievalue: any, env:any): Observable<{}> {
		const params: any = {
			"head": {
				"requestCode": "IIFLMarManagermappingreq",
				"key": "",
				"appVer": "1.0.22.0",
				"appName": "IIFLMarkets",
				"osName": this.commonService.getPlatform(),
				"loginId": dataParams['AdminCode'],
				"userType": this.commonService.get('userType')
			}
		}
		params['body'] = dataParams

		let reqHead = {
				userAgent: "AAA-WebSite",
				appID: this.commonService.get('appID') || '',
				'Ocp-Apim-Subscription-Key' : "",
				'token' : cookievalue
			}
			const config = {
				url: this.mapRM.url,
				key: 'TTParams_Key',
				subKey:'TT_OCP'
			} 
			return this.sendReqTOServer(params, config, reqHead);
	}

	public getAgree(dataParams?: any, cookieValue?: any): Observable<{}> {
		
		const head = {
			"RequestCode": "CVUserType01",
			"Key": "",
			"AppVer": "1.0.22.0",
			"AppName": "AAA",
			"OsName": this.commonService.getPlatform(),
			"userType": this.commonService.get('userType')
		}
		let params: any = {};

		params['head'] = head;
		params['body'] = dataParams;

		let reqHead = {
				userAgent: "AAA-WebSite",
				appID: this.commonService.get('appID') || '',
				'Ocp-Apim-Subscription-Key' : "",
				'token' : cookieValue
			}
			const config = {
				url: this.agree.url,
				key: 'Verify_Guest_And_ExtendedApi',
				subKey:'AAA_OCP'
			} 
			return this.sendReqTOServer(params, config, reqHead);
	}

	public getSubBrokerLogin(userID?: any, dataParams?: any): Observable<{}> {
		const params: any = {
			"head": {
				"requestCode": "IIFLMarRQLR02",
				"key": "",
				"appVer": "1.0.22.0",
				"appName": "AAA",
				"osName": this.commonService.getPlatform(),
				"LoginId": userID,
				"userType": this.commonService.get('userType')
			}
		}
		params['body'] = dataParams

		let reqHead = {
				userAgent: "AAA-WebSite",
				appID: this.commonService.get('appID') || '',
				'Ocp-Apim-Subscription-Key' : "",
			}
			const config = {
				url: this.req1.url,
				key: 'Verify_Guest_And_ExtendedApi',
				subKey:'TT'
			} 
			return this.sendReqTOServer(params, config, reqHead);
	}

	public getSubBrokerMap(dataParams?: any, cookieValue?: any): Observable<{}> {
		let params: any = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "1.0.18.0",
				"OsName": this.commonService.getPlatform(),
				"userType": this.commonService.get('userType')
			}
		};
		params['body'] = dataParams;
		let reqHead = {
				userAgent: "AAA-WebSite",
				appID: this.commonService.get('appID') || '',
				'Ocp-Apim-Subscription-Key' : "",
				'token': cookieValue
			}
			const config = {
				url: this.subMap.url,
				key: 'Verify_Guest_And_ExtendedApi',
				subKey:'AAA_OCP'
			} 

			return this.sendReqTOServer(params, config, reqHead);
	}

		public getToken(obj: any, details: any,  cookieValue?: any) {
		let params: any = {
			"head": {
				"osName": this.commonService.getPlatform(),
				"LoginId": details['UserId'],
				"RequestCode": "IIFLMarRQGTFAAA01",
				"key": "",
				"appVer": "1.0",
				"appName": "IIFLMarkets",
				"userType": this.commonService.get('userType')
			}
		}
		if (obj) params['body'] = obj;
		else params['body'] = {
			JwtAAAToken: details['JwtToken']
		}

		let reqHead = {
				appID: this.commonService.get('appID') || '',
				'Ocp-Apim-Subscription-Key' : "",
				'token': cookieValue
			}
			const config = {
				url: this.getTokenForAAA.url,
				key: 'TTParams_Key',
				subKey:'TT_OCP'
			} 

			return this.sendReqTOServer(params, config, reqHead);
	}

	public accessProductActivation(cookievalue: any,userId: any) {
		let params = { 
			"head": {
				"RequestCode": " ActiveDeactiveRightsBase",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
				//"PartnerCode": "C86730"
				"PartnerCode": userId
			}
		}

		let reqHead = {
				appID: this.commonService.get('appID') || '',
				'Ocp-Apim-Subscription-Key' : "",
				'token': cookievalue
			}
			const config = {
				url: this.productActDea.url,
				key: 'Verify_Guest_And_ExtendedApi',
				subKey:'AAA_OCP'
			} 

			return this.sendReqTOServer(params, config, reqHead);
	}

	public getClientCodes(cookievalue: any, userId: any): Observable<{}> {
		let params = {
			"body": { "Code": userId },
			"head": {
				"AppName": this.clientCodes.appName,
				"AppVer": "1.0.26.0", "Key": "", "OsName": "Android", "RequestCode": "CVUpdateLead01",
				"userType": this.commonService.get('userType')
			}
		}

		let reqHead = {
				'Ocp-Apim-Subscription-Key' : "",
				'appID': this.commonService.get('appID') || '',
				'token': cookievalue
			}
			const config = {
				url: this.clientCodes.url,
				key: 'Verify_Guest_And_ExtendedApi',
				subKey:'AAA_OCP'
			} 
			return this.sendReqTOServerGet(params, config, reqHead);
	}

	public getCrmToken(PartnerCode?:any): Observable<{}> {

		let params = {
            "UserID" :"ED349A8E0DEA4512",
			"Key": "",
			"AppName": "AAA",
			"userType": this.commonService.get('userType')
        }

			let reqHead = {
				appID: this.commonService.get('appID') || '',
				'Ocp-Apim-Subscription-Key' : "",
				'RequestId':PartnerCode == undefined ? this.commonService.get('userId1'): PartnerCode,
			}
			const config = {
				url: this.crmToken.url,
				key: 'Verify_Guest_And_ExtendedApi',
				subKey:'iiflcrm_OCP',
				isKeyInParams: true
			}

			return this.sendReqTOServer(params, config, reqHead);
	}

	public verifyOneLoginUser(jwttoken: any,checksum: any): Observable<{}> {
		let params = { 
			"head": {
				"RequestCode": " CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
				"JWTToken": jwttoken,
				"Checksum": checksum
			}
		}

		let reqHead = {
				appID: this.commonService.get('appID') || '',
				'Ocp-Apim-Subscription-Key' : ""
			}
			const config = {
				url: this.verifyOneLogin.url,
				key: 'Verify_Guest_And_ExtendedApi',
				subKey:'AAA_OCP'
			} 

			return this.sendReqTOServer(params, config, reqHead);
	}

	public getUserDetails(accessToken: any): Observable<{}> {
		let obj = {};
		if (accessToken) {
			obj = {
				'Authorization': 'Bearer ' + accessToken
			}
		}
		return this.httpClient.get(this.userInfoOneLogin.url, { headers: new HttpHeaders(obj) });
	}

	public getAccessControlData(): Observable<{}> {
		const params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
        		"Key": "",
        		"AppName": "AAA",
        		"AppVer": "1.0.4.0",
        		"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
				"Loginid": this.commonService.get('userId1')
			}
		}

		let reqHead = {
				appID: this.commonService.get('appID') || '',
				'Ocp-Apim-Subscription-Key' : "",
				'token': this.commonService.get('brokerageToken'),
			}
			const config = {
				url: this.viewBrokerageRights.url,
				key: 'Verify_Guest_And_ExtendedApi',
				subKey:'AAA_OCP'
			} 

			return this.sendReqTOServer(params, config, reqHead);
	}

	public updateMenuRights(dataParams: any, token: any): Observable<{}> {
		const params: any = {
			"head": {
				"RequestCode": "APIBO52UCVDWFY",
				"Key": "",
				"AppVer": "01",
				"AppName": "AAA",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
		}
		params['body'] = dataParams;
		let reqHead = {
				appID: this.commonService.get('appID') || '',
				'Ocp-Apim-Subscription-Key' : "",
				'token': token
			}
			const config = {
				url: this.addMenuRights.url,
				key: 'Verify_Guest_And_ExtendedApi',
				subKey:'AAA_OCP'
			} 

			return this.sendReqTOServer(params, config, reqHead);
	}

	public getScore(obj: any, cookieValue?: any) {
		if (cookieValue) {
			obj['token'] = cookieValue;
		}

		let reqHead = {
				appID: this.commonService.get('appID') || '',
				'Ocp-Apim-Subscription-Key' : "",
			}
			const config = {
				url: URLS['iglScore']['url'],
				key: 'Verify_Guest_And_ExtendedApi',
				subKey:'AAA_OCP'
			} 
		return this.sendReqTOServer(obj, config, reqHead);
	}

	// new server service call end








	// not to remove static key
	


	


	



	
	

	

	//new login modules service fun //


	

	

	

	

	

	

	





	

	


	

	

	

	

	

// 	public aaaApplicationSettings(): Observable<any> {
// 		this.appSettings = URLS.appSetting;
// 	const params = {};
// 	const headersObj: any = {
// 		'Ocp-Apim-Subscription-Key': this.appSettings.key,
// 	};
// 	const sanitize = (raw: string): string =>
// 		raw.replace(/,\s*([}\]])/g, '$1');
// 	const parseJson = (raw: string) => {
// 		const cleaned = sanitize(raw);
// 		try {
// 			return JSON.parse(cleaned);
// 		} catch (e) {
// 			console.error('JSON parse failed after sanitize', e, cleaned);
// 			return {};
// 		}
// 	};
// 		return this.httpClient
// 			.post(this.appSettings.url, params, {
// 				headers: new HttpHeaders(headersObj),
// 				responseType: 'text',
// 			})
// 			.pipe(
// 				map(parseJson)
// 			);
// }

	screenSize() {
  let deviceWidth = 720;   // 👈 SSR fallback
  let deviceHeight = 1080; // 👈 SSR fallback

  if (isPlatformBrowser(this.platformId)) {
    deviceWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    deviceHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
  }

  return `${deviceWidth}*${deviceHeight}`;
}






}
